import {
  ConfirmationAlert,
  ConfirmationField,
} from "@/shared/foundation/primitives";

import { describeCalendar } from "./boardConfirmationText";

/**
 * The time zone and week start a create or update request gives the board,
 * under `label`, and why the board cannot use them when it cannot. Nothing
 * renders when the request gives none.
 */
export function BoardCalendarField({
  calendar,
  label,
}: {
  calendar: unknown;
  label: string;
}) {
  const description = describeCalendar(calendar);
  if (description === undefined) {
    return null;
  }
  return (
    <ConfirmationField label={label}>
      {description.text}
      {description.problem === undefined ? null : (
        <ConfirmationAlert>{description.problem}</ConfirmationAlert>
      )}
    </ConfirmationField>
  );
}
